module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [(!_vm.is_dengbao) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('p', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'loginByUsername'
      }),
      expression: "{name:'loginByUsername'}",
      modifiers: {
        "replace": true
      }
    }],
    staticClass: "fr link"
  }, [_vm._v("账号密码登录")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo1"
  }), _vm._v(" "), _c('div', {
    staticClass: "h2"
  }, [_vm._v("手机号登录")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "center": "",
      "type": "number",
      "maxlength": "4",
      "clearable": "",
      "placeholder": "请输入短信验证码"
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  }, [_c('van-button', {
    attrs: {
      "slot": "button",
      "size": "small",
      "disabled": _vm.clockSecond > 0,
      "round": "",
      "type": "danger"
    },
    on: {
      "click": _vm.getCode
    },
    slot: "button"
  }, [_vm._v(_vm._s(_vm.clockSecond > 0 ? _vm.clockSecond + 's获取验证码' : '获取验证码'))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("未注册手机验证后自动登录")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "cert-status login-success",
    style: ({
      top: _vm.success ? '0px' : '100%'
    })
  }, [_c('div', {
    staticClass: "cert-status-content"
  }, [_c('div', {
    staticClass: "cert-status-icon-success"
  }), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v("登陆成功")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d39723","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/loginBySms.vue
// module id = 2376
// module chunks = 0